/**
 * Виден ли край пейзажа, где он уходит в черноту. Внутри затухание полностью прозрачно, а
 * картинка затухания натянута на весь пейзаж: в обычной игре это целый экран зря
 * закрашенных пикселей на каждый кадр. Пока край не в кадре, рисовать ее незачем.
 *
 * @param {{x: number, y: number, right: number, bottom: number}} view — видимая область мира
 * @param {{centerX: number, centerY: number, size: number}} place — где лежит пейзаж
 * @param {number} bandFraction — доля стороны пейзажа, на которой идет затухание
 * @returns {boolean}
 */
export const checkIfGroundFadeInView = (view, place, bandFraction) => {
  const clearHalf = place.size * (0.5 - bandFraction);
  return view.x < place.centerX - clearHalf
    || view.right > place.centerX + clearHalf
    || view.y < place.centerY - clearHalf
    || view.bottom > place.centerY + clearHalf;
};
